// React imports
import React from 'react';
import { Flex, Spin } from 'antd';
import en from 'src/messages/en.json';

export const FullScreenLoader = ({
  title,
  showLoader = true,
}: {
  title?: string;
  showLoader?: boolean;
}) => {
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        height: '100vh',
        width: '100vw',
      }}
    >
      {showLoader && <Spin />}
      {title || en.Common.Title.loading}
    </Flex>
  );
};
